import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import './App.css';

import ProtectedRoute from './components/ProtectedRoute';
import Layout from './components/Layout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Products from './pages/Products';
import ProductForm from './pages/ProductForm';
import Stock from './pages/Stock';
import StockReceive from './pages/StockReceive';
import Sales from './pages/Sales';
import Reports from './pages/Reports';
import NotFound from './pages/NotFound';

// Tax pages (Wave 1)
import TaxSummary from './pages/tax/TaxSummary';
import TaxFiling from './pages/tax/TaxFiling';
import TaxFilingList from './pages/tax/TaxFilingList';
import TaxFilingDetail from './pages/tax/TaxFilingDetail';
import TaxClearance from './pages/tax/TaxClearance';

// LRA pages (Wave 2 + Wave 3)
import LRAIntelligence from './pages/lra/Intelligence';
import LRABusinessDirectory from './pages/lra/BusinessDirectory';
import LRABusinessProfile from './pages/lra/BusinessProfile';
import LRAAuditSignals from './pages/lra/AuditSignals';
import LRAReports from './pages/lra/Reports';
import NewRegistration from './pages/lra/NewRegistration';
import RegistrationHistory from './pages/lra/RegistrationHistory';
import RegistrationDetail from './pages/lra/RegistrationDetail';

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />

        <Route
          path="/"
          element={
            <ProtectedRoute>
              <Layout />
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={<Dashboard />} />
          <Route path="products" element={<Products />} />
          <Route path="products/new" element={<ProductForm />} />
          <Route path="products/edit/:id" element={<ProductForm />} />
          <Route path="stock" element={<Stock />} />
          <Route path="stock/receive" element={<StockReceive />} />
          <Route path="sales" element={<Sales />} />
          <Route path="reports" element={<Reports />} />

          {/* Tax (Wave 1) */}
          <Route path="tax/summary" element={<TaxSummary />} />
          <Route path="tax/filing" element={<TaxFilingList />} />
          <Route path="tax/filing/new" element={<TaxFiling />} />
          <Route path="tax/filing/:id" element={<TaxFilingDetail />} />
          <Route path="tax/clearance" element={<TaxClearance />} />

          {/* LRA (Wave 2 + Wave 3) */}
          <Route path="lra/intelligence" element={<LRAIntelligence />} />
          <Route path="lra/businesses" element={<LRABusinessDirectory />} />
          <Route
            path="lra/businesses/:dssn"
            element={<LRABusinessProfile />}
          />
          <Route path="lra/audit-signals" element={<LRAAuditSignals />} />
          <Route path="lra/reports" element={<LRAReports />} />

          {/* LRA Registration (Wave 3) */}
          <Route path="lra/registration/new" element={<NewRegistration />} />
          <Route
            path="lra/registration/history"
            element={<RegistrationHistory />}
          />
          <Route
            path="lra/registration/:registrationId"
            element={<RegistrationDetail />}
          />
        </Route>

        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
